import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VehicleUpdateBodyWithRegistrationDate, VehicleWithRegistrationDate } from "./vehicle.types";

export const VEHICLE_UPDATE_RESOURCE = "vehicle" as const;
export const VEHICLE_UPDATE_API_PATH = `/v1/${VEHICLE_UPDATE_RESOURCE}/{uuid}` as const;

export type VehicleUpdateInput = VehicleUpdateBodyWithRegistrationDate & {
  uuid: string;
};
export type VehicleUpdateResponse = VehicleWithRegistrationDate;

export const useVehicleUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleUpdateResponse, Error, VehicleUpdateInput>({
    mutationFn: async (data: VehicleUpdateInput) => {
      const { uuid, ...body } = data;
      const response = await alphartisApiAxios.patch<VehicleUpdateResponse>(
        `/v1/${VEHICLE_UPDATE_RESOURCE}/${uuid}`,
        body,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_UPDATE_RESOURCE],
      });
    },
  });
};
